import React from 'react';
import { useTranslation } from "react-i18next";
import ErrorAlert from "./ErrorAlert";

const CheckBoxRadioInput = (props) => {
  const { t } = useTranslation();

  return (
    <div className={"form-check checkbox--termscondition" + (props.error ? " not-valid" : "")}>
      <input
        type={props.type}
        name={props.name}
        className="form-check-input"
        checked={props.type === 'radio' ? props.checked : props.value}
        value={props.value}
        onChange={props.handleChange}
        disabled={props.disabled}
        id={props.id}
      />
      <label className="form-check-label">
        {t(props.label)}{" "}
        {props.terms && (
          <a href={window.PRIVACY_BAR_LINK} target="_blank">
            <u>{t(props.terms)}</u>
          </a>
        )}
      </label>

      {props.hint && <i className="fa fa-question-circle" aria-hidden="true">{props.hint}</i>}
      {props.error &&
        <ErrorAlert error={props.error} />
      }
    </div>
  )
};
export default CheckBoxRadioInput;

